import { ChapterRow } from "../../component/management-report/generator/observation-generator/comparaison-generator/expense-operation-comparaison-table";
import { LocalAuthority } from "../../model";
import * as Model from "../../model";


/**
 * @param prevAmountFinder montant prévisionnel du chapitre pour l'année `currentYear`,
 * calculé comme la Synthèse du scénarii de fonctionnement
 */
export function GetChapterValues(chapterRow: ChapterRow, localAuthority: LocalAuthority, currentYear: number, prevAmountFinder: (chapterNumber: string) => number, isReceipts: boolean) {
    const YEARS_FOR_REAL: number[] = [currentYear - 2, currentYear - 1, currentYear]
    let OutChapterValues: number[] = [];

    //Récupération des valeurs pour la partie réalisé N-2
    OutChapterValues.push(getChapterAmountForYear(localAuthority.observations, localAuthority.accounts, YEARS_FOR_REAL[0], chapterRow.chapitreNumber, isReceipts));

    //Récupération des valeurs pour la partie réalisé N-1
    OutChapterValues.push(getChapterAmountForYear(localAuthority.observations, localAuthority.accounts, YEARS_FOR_REAL[1], chapterRow.chapitreNumber, isReceipts));

    //Récupération des valeurs pour la partie prev
    OutChapterValues.push(prevAmountFinder(chapterRow.chapitreNumber));

    //Récupération des valeurs pour la partie réalisé N
    OutChapterValues.push(getChapterAmountForYear(localAuthority.observations, localAuthority.accounts, YEARS_FOR_REAL[2], chapterRow.chapitreNumber, isReceipts));

    //Calcul de la variance
    OutChapterValues.push(computeVariance(OutChapterValues[2], OutChapterValues[3]));

    return OutChapterValues;
}

export function GetChapterLibelle(chapterRow: ChapterRow, localAuthority: LocalAuthority) {
    return localAuthority.accounts.find(o => o.chapter != undefined && o.chapter.number == chapterRow.chapitreNumber);
}

export function computeTotal(chapterRows: ChapterRow[]) {
    const outValues: number[] = [0, 0, 0, 0, 0];
    chapterRows.forEach(row => {
        for (let i = 0; i < outValues.length - 1; i++) {
            outValues[i] += row.values[i];
        }
    });
    outValues[4] = computeVariance(outValues[2], outValues[3])
    return outValues;
}

export function GetChapterList(localAuthAcc: Model.LocalAuthorityChapterAccount[], isFonctionnement: boolean, isDepense: boolean): ChapterRow[] {
    const outChapters: ChapterRow[] = [];
    let filteredLocalAuthAcc;
    if (isDepense) {
        filteredLocalAuthAcc = localAuthAcc.filter(acc => acc.chapter != null && acc.account != null && acc.account.operation == isFonctionnement && acc.account.expense);
    } else {
        filteredLocalAuthAcc = localAuthAcc.filter(acc => acc.chapter != null && acc.account != null && acc.account.operation == isFonctionnement && acc.account.receipts);
    }
    let distinctChap = filteredLocalAuthAcc.filter((acc, i, arr) => arr.findIndex(t => t.chapter.id == acc.chapter.id) == i)
    distinctChap.forEach(chap => {
        outChapters.push({
            chapitreNumber: chap.chapter.number, chapitreLibelle: "", values: []
        });
    })
    return outChapters;
}

function computeVariance(prev: number, real: number): number {
    if (prev != 0 && prev != undefined) {
        return ((real - prev) / prev);
    } else {
        return 0;
    }
}

export function getChapterAmountForYear(observations: Model.Observation[], accounts: Model.LocalAuthorityChapterAccount[], year: number, chapterNumber: string, isReceipts: boolean): number {
    let chapterAmount: number = 0;
    let chapterAccounts = accounts.filter(acc => acc.chapter != null && acc.chapter.number == chapterNumber);
    if (chapterAccounts) {
        chapterAccounts.forEach(acc => {
            let obsIdx = observations.findIndex(o => o.account.id == acc.account.id && o.year == year && o.receipts == isReceipts);
            if (obsIdx != -1) {
                chapterAmount = (chapterAmount * 100 + observations[obsIdx].amount * 100) / 100;
            }
        });
    }
    return chapterAmount;
}


// WEBPACK FOOTER //
// ./src/domain/sfp/comparaison-domain.ts